import React from 'react';
import { ShareBox } from '@eb/eds-share-box';
import { trackShareAction } from '../../tracking/trackShareAction';
import { ShareEventModalProps } from '../ShareEventModal/ShareEventModal';

export const TrackedShareEvent = (shareEventProps: ShareEventModalProps) => {
    type shareType =
        | 'facebook'
        | 'linkedin'
        | 'whatsapp'
        | 'facebookMessenger'
        | 'twitter'
        | 'email';

    const shareMapping = {
        facebook: 'fb',
        linkedin: 'li',
        whatsapp: 'wa',
        facebookMessenger: 'fbm',
        twitter: 'tw',
        email: 'strongmail',
    };

    const label = (id: shareType): string => shareMapping[id];

    return (
        <ShareBox
            onClick={(id: shareType) => trackShareAction(label(id))}
            {...shareEventProps}
        />
    );
};
